// src/main.jsx

import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import { store } from './store/Store';
import App from './App';

import { PublicClientApplication, EventType } from '@azure/msal-browser';
import { msalConfig } from '../authConfig.js';
import { MsalProvider } from '@azure/msal-react';
import { AuthProvider } from './components/context/AuthContext.js';
import { FormProvider } from './components/context/FormContext.js';
import "./i18n.js"

// ** Google Analytics Integration **
/*Solo si existe la variable de entorno (que estará solo en el .env de produccuión) */
if (import.meta.env.PROD && import.meta.env.VITE_GOOGLE_ANALYTICS_ID) {
  const analyticsId = import.meta.env.VITE_GOOGLE_ANALYTICS_ID;
  
  // Create and append the gtag.js script
  const scriptTag = document.createElement('script');
  scriptTag.async = true;
  scriptTag.src = `https://www.googletagmanager.com/gtag/js?id=${analyticsId}`;
  document.head.appendChild(scriptTag);
  
  // Create and append the inline script for dataLayer
  const inlineScript = document.createElement('script');
  inlineScript.innerHTML = `
    window.dataLayer = window.dataLayer || [];
    function gtag(){dataLayer.push(arguments);}
    gtag('js', new Date());
    gtag('config', '${analyticsId}');
  `;
  document.head.appendChild(inlineScript);
}



// ** The rest of your React rendering code **
ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <Provider store={store}>
      {/* <MsalProvider instance={msalInstance}> */}
        <FormProvider>
          <AuthProvider>
            <BrowserRouter>
              <App />
            </BrowserRouter>
          </AuthProvider>
        </FormProvider>
      {/* </MsalProvider> */}
    </Provider>
  </React.StrictMode>
);